import {
  GET_CORPORATE_MASTER_DATA_LIST_SUCCESS, GET_CORPORATE_MASTER_DATA_LIST_FAILURE,CORPORATE_MASTER_TEMPLATE_SUCCESS,CORPORATE_MASTER_TEMPLATE_FAILURE,
  CORPORATE_MASTER_DATA_UPLOAD_SUCCESS,CORPORATE_MASTER_DATA_UPLOAD_FAILURE,CORPORATE_MASTER_DATA_EXCEL_SUCCESS, CORPORATE_MASTER_DATA_EXCEL_FAILURE,
  CORPORATE_MASTER_GET_CORPORATES_REQUEST, CORPORATE_MASTER_GET_CORPORATES_SUCCESS, CORPORATE_MASTER_GET_CORPORATES_FAILURE} from "./action";
const initialState = {
  addCorporateMasterUploadSuccess: [],
  addCorporateMasterUploadFailure: [],
  corporateMasterListSuccess: null,
  corporateMasterListFailure: null,
  corporates: [],
  corporatesLoading: false,
  corporatesError: null,
};

const corporateMasterReducer = (state = initialState, action) => {
  switch (action.type) {

    case 'CORPORATE_MASTER_LIST_SUCCESS':
      return {
        ...state,
        corporateMasterListSuccess: action.data
      };

      case 'CORPORATE_MASTER_LIST_FAILURE':
        return {
          ...state,
          corporateMasterListFailure: action.data
        };

    case CORPORATE_MASTER_TEMPLATE_SUCCESS:
      return {
        ...state,
        corporateMasterTemplateSuccess: action.data,
      };

    case CORPORATE_MASTER_TEMPLATE_FAILURE:
      return {
        ...state,
        corporateMasterTemplateFailure: action.data,
      };

    case CORPORATE_MASTER_DATA_UPLOAD_SUCCESS:
      return {
        ...state,
        addCorporateMasterUploadSuccess: action.data,
      };

    case CORPORATE_MASTER_DATA_UPLOAD_FAILURE:
      return {
        ...state,
        addCorporateMasterUploadFailure: action.data,
      };
    case CORPORATE_MASTER_DATA_EXCEL_SUCCESS:
      return {
        ...state,
        corporateMasterDataExcelSuccess: action.data
      }

    case CORPORATE_MASTER_DATA_EXCEL_FAILURE:
      return {
        ...state,
        corporateMasterDataExcelFailure: action.data
      }

    case CORPORATE_MASTER_GET_CORPORATES_REQUEST:
      return {
        ...state,
        corporatesLoading: true,
        corporatesError: null,
      };

    case CORPORATE_MASTER_GET_CORPORATES_SUCCESS:
      return {
        ...state,
        corporatesLoading: false,
        corporates: action.data,
      };

    case CORPORATE_MASTER_GET_CORPORATES_FAILURE:
      return {
        ...state,
        corporatesLoading: false,
        corporatesError: action.data,
      };

    default:
      return state;
  }
};
export default corporateMasterReducer;
